// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__PmbGT","skeleton_user":"Skeleton_skeleton_user__193rX","img":"Skeleton_img__3-_6x","content":"Skeleton_content__2IYNT"};